<template>
<div class="hands">
  <div class="hands__left"></div>
  <div class="hands__right"></div>
</div>
</template>

<script>
export default {
  name: 'hands'
}
</script>

<style lang="scss">
@keyframes clap-left {
  0% {
    transform: translate3d(0%,0%,0) rotate3d(0,0,0,0deg);
  }
  20% {
    transform: translate3d(0%,0%,0) rotate3d(0,0,0,0deg);
  }
  40% {
    transform: translate3d(-10%,-15%,0) rotate3d(0,0,1,-10deg);
  }
  60% {
    transform: translate3d(-10%,-15%,0) rotate3d(0,0,1,-10deg);
  }
  80% {
    transform: translate3d(0%,0%,0) rotate3d(0,0,0,0deg);
  }
  100% {
    transform: translate3d(0%,0%,0) rotate3d(0,0,0,0deg);
  }
}
@keyframes clap-right {
  0% {
    transform: translate3d(0%,0%,0) rotate3d(0,0,0,0deg);
  }
  20% {
    transform: translate3d(0%,0%,0) rotate3d(0,0,0,0deg);
  }
  40% {
    transform: translate3d(10%,10%,0) rotate3d(0,0,1,10deg);
  }
  60% {
    transform: translate3d(10%,10%,0) rotate3d(0,0,1,10deg);
  }
  80% {
    transform: translate3d(0%,0%,0) rotate3d(0,0,0,0deg);
  }
  100% {
    transform: translate3d(0%,0%,0) rotate3d(0,0,0,0deg);
  }
}
.hands {
  position: relative;
  width: fluid(103px);
  height: fluid(85px);
  &__left {
    z-index: 1;
    position: absolute;
    top: fluid(5px);
    left: 0;
    width: fluid(97px);
    height: fluid(71px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-image: url('~@/assets/img/hand-left.svg');
    transform-origin: 0% 100%;
  }
  &__right {
    position: absolute;
    top: 0;
    right: 0;
    width: fluid(88px);
    height: fluid(85px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-image: url('~@/assets/img/hand-right.svg');
    transform-origin: 0% 100%;
  }
}
.hands-clapping {
  .hands__left {
    animation: clap-left 0.75s linear infinite;
  }
  .hands__right {
    animation: clap-right 0.75s linear infinite;
  }
}
</style>